<script>
	import { store } from "$lib/utilities/store";
	import Loading from "./Loading.svelte";

	export let count;
	export let total;
	export let status = "Updated";
	export let collection;
	export let alias;
	export let condition = null;

	$: watchCondition =
		condition ||
		`${($store.userProfile?.collectionCriteria?.[collection]?.search || "") === "" ? `` : ` containing "${$store.userProfile.collectionCriteria?.[collection]?.search}"`}`;
	$: displayAlias = alias ?? collection ?? "";
	$: countLabel =
		count === total || total == null
			? `${total ?? count ?? 0}`
			: `${count ?? 0} of ${total ?? 0}`;
	$: recordCountText =
		[countLabel, displayAlias].filter(Boolean).join(" ") + (watchCondition || "");
</script>

<div class="p-2 bg-base-300">
	{#if status !== "Updated"}
		<Loading />
	{:else}
		{recordCountText}
	{/if}
</div>
